import React from "react";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDPagination from "components/MDPagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";

function Pagination({ itemsPerPage, totalItems, currentPage, onPageChange }) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  const renderPageNumbers = () => {
    // Logic to decide which page numbers to show
    if (totalPages <= 7) {
      // Show all pages if 7 or less
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
        <MDPagination item key={number} onClick={() => onPageChange(number)} active={currentPage === number}>
          {number}
        </MDPagination>
      ));
    }

    // Logic for more than 7 pages
    const pages = [];
    if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, "...", totalPages);
    } else if (currentPage > totalPages - 4) {
      pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
    }

    return pages.map((page, index) => {
      if (typeof page === "string") {
        return (
          <MDPagination item key={`ellipsis-${index}`} disabled>
            {page}
          </MDPagination>
        );
      }
      return (
        <MDPagination item key={page} onClick={() => onPageChange(page)} active={currentPage === page}>
          {page}
        </MDPagination>
      );
    });
  };

  const firstItem = (currentPage - 1) * itemsPerPage + 1;
  const lastItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <MDBox
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={3}
      px={2}
      py={1}
    >
      <MDTypography variant="body2" color="text">
        Mostrando {firstItem}-{lastItem} de {totalItems} resultados
      </MDTypography>
      <MDPagination>
        <MDPagination item onClick={handlePrev} disabled={currentPage === 1}>
          <Icon>keyboard_arrow_left</Icon>
        </MDPagination>
        {renderPageNumbers()}
        <MDPagination item onClick={handleNext} disabled={currentPage === totalPages}>
          <Icon>keyboard_arrow_right</Icon>
        </MDPagination>
      </MDPagination>
    </MDBox>
  );
}

Pagination.propTypes = {
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination; 